export const tagState = () => ({
  tagList: [],
  tagSelect: [],
});

export const actions = {
  setTagList({ commit }: any, tagList: Tag[]) {
    commit('setTagList', tagList);
    commit('setTagSelect', tagList);
  },
};

export const mutations = {
  setTagList(state: any, tagList: Tag[]) {
    state.tagList = tagList;
  },
  setTagSelect(state: any, tagList: Tag[]) {
    state.tagSelect = tagList.map((tag) => ({
      text: tag.tagName,
      value: tag.tagId,
    }));
  },
};

export default {
  namespaced: true,
  state: tagState,
  actions,
  mutations,
};
